import React from 'react';
import dynamic from 'next/dynamic';
import { withSessionSsr } from '@/shared/utils/session';
import { GetServerSidePropsContext } from 'next';

const ViewNoSSR = dynamic(() => import('src/modules/close-account/presentation/interface/login'), {
  ssr: false,
});

export const getServerSideProps = withSessionSsr(function handler({
  req,
}: GetServerSidePropsContext) {
  const { session } = req;
  if (session) {
    return {
      props: { session },
    };
  }
  return {
    notFound: true,
  };
},
'CloseAccount');

const LoginCloseAccount = (props: any) => <ViewNoSSR {...props} />;

export default LoginCloseAccount;
